import { render, staticRenderFns } from "./widget-image-gallery.vue?vue&type=template&id=6af3d470&scoped=true&"
import script from "./widget-image-gallery.vue?vue&type=script&lang=ts&"
export * from "./widget-image-gallery.vue?vue&type=script&lang=ts&"
import style0 from "./widget-image-gallery.vue?vue&type=style&index=0&id=6af3d470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3d470",
  null
  
)

export default component.exports